

import React from "react"

const TorchIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 452.96 454.1">
    <path fill="currentColor" d="M102.68 169.51a67.69 67.69 0 0 0 .53 8.35L180 101a69.88 69.88 0 0 0-8.36-.52 69.07 69.07 0 0 0-68.96 69.03z" transform="translate(-58.14 -55.98)"/>
    <path d="M102.68 169.51a69.07 69.07 0 0 1 69-69 69.88 69.88 0 0 1 8.32.49l24.8-24.8A99 99 0 0 0 78.4 202.67l24.81-24.81a67.69 67.69 0 0 1-.53-8.35z" transform="translate(-58.14 -55.98)"/>
    <path className="cls-1" transform="rotate(-45 255.236 393.048)" d="M300.06 237.3H403.7v227.11H300.06z"/>
    <path className="cls-1" d="M201.27 85.91L85.68 201.5l66.86 31.7 79.63-79.63-30.9-67.66zM337.39 454.1l55.9-55.9-28.37 28.37-27.53 27.53z"/>
    <path className="cls-1" transform="rotate(-45 75.03 211.702)" d="M83.52 156.9h176.3v25.22H83.52z"/>
    <path d="M320.7 204.11l-44.16-96.68L225.09 56l-20.26 20.24L180 101l-76.82 76.82-24.78 24.85-20.26 20.26 51.37 51.37 95.54 45.3 13.6 13.6 21.14 21.14 155.74 155.74 27.53-27.53 28.37-28.37 30.29-30.28 29.38-29.39zm-220.28 18.82L225.09 98.26l17.83 17.83-124.66 124.67zm110.26 66.25l-66.86-31.7 115.59-115.59 30.9 67.66zM395.53 467.8L234.94 307.2l73.28-73.28 160.6 160.59z" transform="translate(-58.14 -55.98)"/>
  </svg>
)

export default TorchIcon



// WEBPACK FOOTER //
// ./src/AtomicComponents/Icons/TorchIcon.jsx